import GSAP from "gsap";
export default class {
  constructor() {
    this.preloaderTimeline = GSAP.timeline({
      onComplete: () => {
        document.body.style.overflow = "auto";
        localStorage.setItem("preloaderShown", true);
      },
    });
    this.timelineConfig = {
      firstCharComeFromBottom: {
        y: 0,
        duration: 0.4,
        stagger: 0.25,
      },
      dotAppear: {
        transform: "scale(1)",
        duration: 0.5,
        stagger: 0.25,
      },
      otherCharAppear: {
        opacity: 1,
        duration: 0.5,
        stagger: 0.04,
      },
      centerWordsHideTop: {
        y: "-100%",
        duration: 0.4,
        stagger: 0.5,
      },
      topHeaderWordsAppear: {
        y: "0%",
        duration: 0.4,
        stagger: 0.5,
      },
      preloaderContainerHide: {
        opacity: 0,
        duration: 0.2,
      },
      tabLineDraw: {
        "--line-draw-height": "100%",
        duration: 0.45,
        stagger: 0.2,
      },
      tabTextReveal: {
        opacity: 1,
        duration: 0.45,
        stagger: 0.2,
      },
      heroSectionLineDraw: {
        "--line-draw-width": "100%",
        duration: 0.45,
        ease: "none",
      },
      heroSectionElementsReveal: {
        opacity: 1,
        duration: 0.6,
        stagger: 0.2,
      },
      heroSectionImageReveal: {
        opacity: 1,
        duration: 0.5,
      },
    };
    if (localStorage.getItem("preloaderShown")) {
      document.body.style.overflow = "auto";
      this.defaultStateNoPreloader();
    } else {
      document.body.style.overflow = "hidden";
      if (window.innerWidth > 1024) {
        this.initAnimation();
      } else {
        this.defaultStateNoPreloader();
      }
    }
  }
  initAnimation() {
    const preloader = document.querySelector(".preloader");
    if (!preloader) return;
    // char come from the bottom
    this.preloaderTimeline.to(preloader.querySelectorAll(".first"), {
      ...this.timelineConfig.firstCharComeFromBottom,
    });
    // dots appear
    this.preloaderTimeline.to(preloader.querySelectorAll(".dot"), {
      ...this.timelineConfig.dotAppear,
    });
    // other character appear
    this.preloaderTimeline.to(preloader.querySelectorAll(".single-char"), {
      ...this.timelineConfig.otherCharAppear,
    });
    // words hide top one by one
    this.preloaderTimeline.to(preloader.querySelectorAll(".name"), {
      ...this.timelineConfig.centerWordsHideTop,
    });
    // top left header logo appear one by one words
    this.preloaderTimeline.to(
      preloader.querySelectorAll(".words"),
      {
        ...this.timelineConfig.topHeaderWordsAppear,
      },
      "<",
    );
    this.preloaderTimeline.to(preloader, {
      ...this.timelineConfig.preloaderContainerHide,
      onComplete: () => {
        preloader.remove();
      },
    });
    // header line and opacity animation section
    const header = document.querySelector("header");
    if (!header) return;
    this.preloaderTimeline.to(header.querySelectorAll(".single__menu__item"), {
      ...this.timelineConfig.tabLineDraw,
    });
    this.preloaderTimeline.to(
      header.querySelectorAll("span"),
      {
        ...this.timelineConfig.tabTextReveal,
      },
      "<",
    );

    // hero section line and opacity animation section
    const heroSection = document.querySelector(".hero__section__wrapper");
    if (!heroSection) return;
    GSAP.set(heroSection.querySelector(".project__info__wrapper"), {
      "--line-draw-width": "0%",
    });
    GSAP.set(heroSection.querySelectorAll(".preload-element"), {
      opacity: 0,
    });
    GSAP.set(heroSection.querySelector(".project__imagebox"), {
      opacity: 0,
    });

    this.preloaderTimeline.to(
      heroSection.querySelector(".project__info__wrapper"),
      {
        ...this.timelineConfig.heroSectionLineDraw,
      },
    );
    this.preloaderTimeline.to(
      heroSection.querySelectorAll(".preload-element"),
      {
        ...this.timelineConfig.heroSectionElementsReveal,
      },
      "<",
    );
    this.preloaderTimeline.to(heroSection.querySelector(".project__imagebox"), {
      ...this.timelineConfig.heroSectionImageReveal,
      
    },"<");
  }
  defaultStateNoPreloader() {
    const preloader = document.querySelector(".preloader");
    if (preloader) {
      preloader.remove();
    }

    // Only set these if they exist — don't block preloader removal
    const header = document.querySelector("header");
    const heroSection = document.querySelector(".hero__section__wrapper");

    if (header) {
      GSAP.set(header.querySelectorAll(".single__menu__item"), {
        "--line-draw-height": "100%",
      });
      GSAP.set(header.querySelectorAll("span"), {
        opacity: 1,
      });
    }

    if (heroSection) {
      GSAP.set(heroSection.querySelector(".project__info__wrapper"), {
        "--line-draw-width": "100%",
      });
      GSAP.set(heroSection.querySelectorAll(".preload-element"), {
        opacity: 1,
      });
      GSAP.set(heroSection.querySelector(".project__imagebox"), {
        opacity: 1,
      });
    }
  }
}
